<template>
  <div class="checkbox">
    <input type="checkbox" :name="name" :id="buttonID" :disabled="disabled" :checked="value" @change="toggle">
    <label :for="buttonID">
      <span class="check"><icon-checkbox /></span>
      <span>{{ label }}</span>
    </label>
  </div>
</template>

<script>
import IconCheckbox from '@/assets/images/icons/checkbox_checked.svg';

export default {
  name: 'checkbox',
  components: {
    IconCheckbox
  },
  props: {
    name: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    label: String,
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonID() {
      return this.id || 'checkbox-' + this._uid
    }
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
input[type=checkbox] {
  display: none;

  &:disabled + label {
    cursor: default;
  }

  &:not(:checked) + label .check svg .checkmark {
    opacity: 0;
  }
}
label {
  font-weight: 600;
  position: relative;
  user-select: none;
  
  .check {
    display: inline-block;
    margin-right: 1em;
    max-width: em(26);
    max-height: em(20);
    vertical-align: middle;

    svg {
      max-width: em(26);
      max-height: em(20);
      
      .checkmark {
        transition: opacity 100ms;
      }
    }
  }
}
</style>
